/**
 * Stable fallbacks for Redux selectors. Using `|| []` or `|| {}` in or after
 * useSelector creates new references each run and triggers unnecessary rerenders.
 */
export const EMPTY_ARRAY: never[] = []
export const EMPTY_OBJECT: Record<string, never> = {}
